export default "__VITE_ASSET__CrTLk4UH__"